import { Spin } from "antd";
import React from "react";
import Page, { PageProps } from "../../core/ui/pages/Page";
import { IGenericCodebookPresenter } from "../presenter/GenericCodebookPresenter";

import GenericCodebookGrid from "./GenericCodebookGrid";

export interface Props extends PageProps {}

export interface State extends IGenericCodebookPresenter {}

export default class GenericCodebookPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      updateGenericCodebookItem,
      createGenericCodebookItem,
      selectedCodebook,
      codebookItemList
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {selectedCodebook && (
          <Spin spinning={this.state.loaders.codebookItemsLoader}>
            <GenericCodebookGrid
              translate={translate}
              updateGenericCodebookItem={updateGenericCodebookItem}
              createGenericCodebookItem={createGenericCodebookItem}
              selectedCodebook={selectedCodebook}
              codebookItemList={codebookItemList}
              referenceListLoader={this.state.loaders.referenceListLoader}
            />
          </Spin>
        )}
      </Page>
    );
  }
}
